import React from 'react'
import { HelpText } from './helpText'
import { ReturnButton } from './returnButton'

const BadRequest = () => {
  return (
    <div data-testid="complaint-badrequest">
      <h2>Sorry!</h2>
      <p>
        There was an error submitting your complaint. <HelpText />
      </p>
      <ReturnButton />
    </div>
  )
}

export default BadRequest
